export const checkForUpdates = async () => {
  try {
    const res = await fetch(`/meta.json?ts=${Date.now()}`);
    if (!res.ok) return;

    const { version: latestVersion } = await res.json();
    const cachedVersion = localStorage.getItem('app_version');

    console.log("Stored Version:", cachedVersion);
    console.log("Latest Version:", latestVersion);

    if (cachedVersion && latestVersion !== cachedVersion) {
      console.log(`New version detected (${latestVersion} vs ${cachedVersion})`);
      if (!document.hidden) {
        const confirmRefresh = window.confirm(
          `New version (${latestVersion}) available. Refresh now?`
        );
        if (confirmRefresh) {
          localStorage.setItem('app_version', latestVersion);
          window.location.reload(true);
        }
      }
    } else {
      localStorage.setItem('app_version', latestVersion);
    }
  } catch (error) {
    console.error("Version check failed:", error);
  }
};
